export default function isSquareSpecialOrCapturer(
  state: string[][],
  row: number,
  col: number,
  capturer: string
): boolean {
  const isEdge = row < 0 || row >= 11 || col < 0 || col >= 11;
  // Returning now prevents the subsequent lines to throw IndexErrors.
  if (isEdge) return true;
  const isCorner =
    (row == 0 && col == 0) ||
    (row == 0 && col == 10) ||
    (row == 10 && col == 0) ||
    (row == 10 && col == 10);
  const isCenter = row == 5 && col == 5 && state[5][5] == "o";
  const isCapturer = capturer.includes(state[row][col]);
  return isCorner || isCenter || isCapturer;
}
